import { getEarnPointsAction } from "../../../../Actions/LogicActions/TrainOffer/GetEarnPointsAction";
import { getTrainOfferContinueAction } from "../../../../Actions/LogicActions/TrainOffer/GetTrainOfferContinueAction";
import { getPassengerDetailsAction } from "../../../../Actions/LogicActions/Checkout/PassengerDetails/GetPassengerDetailsAction";
import { passengerTicketSummaryAction } from "../../../../Actions/UIActions/TrainOffer/PassengerTicketSummaryAction";
import { ticketTypeRadioChangeAction } from "../../../../Actions/UIActions/TrainOffer/TicketTypeRadioChangeAction";
import { KeyCloakService } from "../../../../Auth/KeyCloak";
import { ExecutionStatus } from "../../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { getSearchSelectedPassenger } from "../../../../Lib/Utils/passenger";
import { trainOfferEvtTree } from "../../../../Orchestrator/ConstantTree";
import { changeDateTree } from "../../../../Orchestrator/ConstantTree/ChangeDatePage/ChangeDateTree";
import { getRecoilStateValue } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { BackToBookingClickType, IBookingResponse, OffersRequest, PassengerSetType, SearchStateType, TicketRadioType, TrainOfferRequest } from "../../../../Orchestrator/Types/Index";
import { IEarnPointsRequest } from "../../../../Orchestrator/Types/Interface/ActionParams/EarnPointsActionParams";
import { TrainType } from "../../../../Orchestrator/Types/Types/TrainTypes";
import { TicketOptionContext } from "../Context/TicketOptionContext";

class TicketOptionPageStep extends StepFlow {
    get stepName() { return "TicketOption_Step"; }

    async onEventSetup(): Promise<void> {

        this.registerEventSubscription(
            _eventBus.on<TicketRadioType, void>({
                eventName: trainOfferEvtTree.Offer.TrainType.Radio.Change,
                handler: (payload) => {
                    let context = this.getCtx<TicketOptionContext>("ticketOptionContext")!;
                    context.ticketRadioType = payload.data!;
                    ticketTypeRadioChangeAction.setParams({ ...context.ticketRadioType });
                    ticketTypeRadioChangeAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<PassengerSetType, void>({
                eventName: trainOfferEvtTree.Offer.Passenger.Set,
                handler: (payload) => {
                    let context = this.getCtx<TicketOptionContext>("ticketOptionContext")!;
                    context.passengerSetType = payload.data!;
                    passengerTicketSummaryAction.setParams({ ...context.passengerSetType });
                    passengerTicketSummaryAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: trainOfferEvtTree.Offer.ContinueToNextStep,
                handler: () => {
                    const searchStates = getRecoilStateValue<SearchStateType>("searchStateAtom");
                    const { totalPassengerCount, passengerCounts } = getSearchSelectedPassenger(searchStates?.passengers);
                    const offerId = getRecoilStateValue<string>("selectedOfferIdAtom");
                    const outboundOfferId = getRecoilStateValue<string>("outboundOfferIdAtom");
                    const isAnonymous = getRecoilStateValue<boolean>("isAnonymousStateAtom") || false;
                    const currentTrainType = getRecoilStateValue<string>("trainTypeAtom");
                    const offersRequest = getRecoilStateValue<OffersRequest>("offersRequestAtom");
                    const selectedOutboundTrain = getRecoilStateValue<TrainType>("selectedOutboundTrainAtom");
                    const selectedInboundTrain = getRecoilStateValue<TrainType>("selectedInboundTrainAtom");
                    const inboundSearchState = getRecoilStateValue<SearchStateType>("inboundSearchStateAtom");
                    const shuttleOfferId = getRecoilStateValue<string>("selectedShuttleOfferIdAtom");
                    const booking = getRecoilStateValue<IBookingResponse>("bookingResponseAtom");
                    const outboundShuttleOfferIdAtom = getRecoilStateValue<string>("outboundShuttleOfferIdAtom");
                    const selectedPassengerForCancel = getRecoilStateValue<string[]>("selectedPassengerForCancelAtom");
                    const selectedPassengerForCancelInBound = getRecoilStateValue<string[]>("selectedPassengerForCancelInBoundAtom");
                    const inboundSelectedChangeDateAtom = getRecoilStateValue<string>("inboundSelectedChangeDateAtom");
                    const selectedChangeDateAtom = getRecoilStateValue<string>("selectedChangeDateAtom");
                    const SelectedOfferIdChangeDateAtom = getRecoilStateValue<string>("SelectedOfferIdChangeDateAtom");
                    const isBookReturnJourney = getRecoilStateValue<boolean>("isBookReturnJourneyAtom");
                    const selectedTrain = getRecoilStateValue<TrainType>("selectedTrainStateAtom");
                    const changeTripAlreadyPaidAddons = getRecoilStateValue<any>("changeTripAlreadyPaidAddonsAtom");

                    if (searchStates && offerId && currentTrainType) {
                        let payload: TrainOfferRequest = {
                            search: searchStates,
                            offerId: offerId,
                            isAnonymous: isAnonymous,
                            totalPassengerCount: totalPassengerCount,
                            passengerCounts: passengerCounts,
                            currentTrainType: currentTrainType,
                            outboundOfferId: outboundOfferId,
                            offersRequest: offersRequest,
                            selectedOutboundTrain: selectedOutboundTrain,
                            selectedInboundTrain: selectedInboundTrain,
                            inboundSearchState: inboundSearchState,
                            shuttleOfferId: shuttleOfferId,
                            outboundShuttleOfferId: outboundShuttleOfferIdAtom,
                            booking: booking,
                            selectedChangeDateAtom: selectedChangeDateAtom,
                            inboundSelectedChangeDateAtom: inboundSelectedChangeDateAtom,
                            selectedPassengerForCancel: selectedPassengerForCancel,
                            selectedPassengerForCancelInBound: selectedPassengerForCancelInBound,
                            isChangeDate: false,
                            SelectedOfferIdChangeDateAtom: SelectedOfferIdChangeDateAtom,
                            searchStates: searchStates,
                            selectedTrain: selectedTrain,
                            changeTripAlreadyPaidAddons: changeTripAlreadyPaidAddons,
                            isBookReturnJourney: isBookReturnJourney
                        }

                        _eventBus.emit({
                            eventName: trainOfferEvtTree.Offer.Continue.Click,
                            data: payload
                        });
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<TrainOfferRequest, void>({
                eventName: trainOfferEvtTree.Offer.Continue.Click,
                handler: async (payload) => {
                    let context = this.getCtx<TicketOptionContext>("ticketOptionContext")!;
                    context.trainOfferRequest = payload.data!;
                    // Pre-warm the passenger atoms in parallel with the
                    // POST /bookings round-trip below. /me is normally a
                    // session cache hit (Topbar pre-fetched it on auth), so
                    // savedPassengerDetailAtom / userDataAtom land before
                    // /checkout mounts — the form renders pre-populated
                    // instead of flashing empty fields. clearBookingFlowAtoms()
                    // wiped these on the user's last search, so we must
                    // re-emit before the route change.
                    if (!payload.data!.isAnonymous) {
                        getPassengerDetailsAction.execute();
                    }
                    await getTrainOfferContinueAction.setParams({ ...context.trainOfferRequest });
                    await getTrainOfferContinueAction.execute();
                    if (getTrainOfferContinueAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        const data = getTrainOfferContinueAction.result!;
                        if (data.returnText === "success" && data.checkoutRedirect == true) {
                            /**
                             * This is because, from here checkout flow will start but if pathname is /checkout then orchestrator also start checkout flow 
                             * Now I have two time Checkout flow is running so to avoid it I set checkoutFromWithLogin true
                             * This flag will be used in orchestrator if it is true then it will not start checkout flow again
                            */
                            sessionStorage.setItem("checkoutFromWithLogin", "true")


                            if (payload.data!.isChangeDate) {
                                context.isAnonymous = payload.data!.isAnonymous;
                                context.routeTo = ["CheckoutFlow"]
                                this.next()
                            }
                            else {
                                context.routeTo = []
                                this.next()
                            }

                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: "/checkout",
                            })
                        }
                        else if (data.returnText === "needLogin") {
                            KeyCloakService.login();
                        }
                        else {
                            //Add to run the flow again for the Round Trip Selection
                            context.routeTo = [];
                            context.nextTo = ["SelectOfferFlow", "TicketOptionFlow"]
                            this.next();
                        }
                    }
                }
            })
        )

        /**
         * This event handle back click event form the CDT offer selection
         * We need to close TickerOptionFlow if user click on back from CDT offer selection page
        */
        this.registerEventSubscription(
            _eventBus.on<BackToBookingClickType, void>({
                eventName: changeDateTree.ChangeDate.BackToBookingClick,
                handler: async ({ data }) => {
                    if (data?.flow === "ChangeDateFlow") {
                        const context = this.getCtx<TicketOptionContext>("ticketOptionContext");
                        if (context) {
                            context.routeTo = []
                            this.next()
                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IEarnPointsRequest, void>({
                eventName: trainOfferEvtTree.Offer.EarnPoints.Get,
                handler: async (payload) => {
                    getEarnPointsAction.setParams({ ...payload.data! });
                    await getEarnPointsAction.execute();
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        console.log("Ticket Option step call............")
    }

}
export const ticketOptionStepDefinition = new StepDefinition({
    stepName: "TicketOption_Step",
    stepClass: TicketOptionPageStep
});